/*jshint esversion: 6 */

import $ from 'jquery';

function navigationToggle() {
  const $body = $('body');
  const $navigationButton = $('.page-header__nav-toggle');
  const $overlay = $('.mobile-navigation');

  const bodyClassOverlayOpen = 'navigation-open';

  const showOverlay = () => {
    $body.addClass(bodyClassOverlayOpen);

    setTimeout(() => {
      const $firstLink = $overlay.find('a').first();
      if ($firstLink.length) {
        $firstLink.focus();
      } else {
        $navigationButton.focus();
      }
    }, 50);

    $(document).on('keydown.navigation-toggle', (event) => {
      if (event.key === 'Escape') {
        hideOverlay();
      }
    });

    $(document).on('focusin.navigation-toggle', (event) => {
      if (!$overlay[0].contains(event.target) &&
          !$navigationButton[0].contains(event.target)) {
        hideOverlay();
      }
    });
  };

  const hideOverlay = () => {
    $navigationButton.attr('aria-expanded', false);

    $body.removeClass(bodyClassOverlayOpen);

    $(document).off('focusin.navigation-toggle');
    $(document).off('keydown.navigation-toggle');

    $navigationButton.focus();
  };

  $navigationButton.on('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    if ($body.hasClass(bodyClassOverlayOpen)) {
      hideOverlay();
    } else {
      showOverlay();
    }
  });
}

export default navigationToggle;
